export const getStartOfCurrentWeek = (offset = 0): Date => {
	const now = new Date();
	const day = now.getUTCDay();
	const daysFromTodayToMonday = (day + 6) % 7;

	return new Date(
		Date.UTC(
			now.getUTCFullYear(),
			now.getUTCMonth(),
			now.getUTCDate() - daysFromTodayToMonday + offset * 7,
			0,
			0,
			0,
			0,
		),
	);
};
